import { render, staticRenderFns } from "./flash.vue?vue&type=template&id=0cfd4da6&"
import script from "./flash.vue?vue&type=script&lang=js&"
export * from "./flash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports